const MasterCardIcon = ({ ...props }) => {
  return (
    <svg
      width="55"
      height="30"
      viewBox="0 0 55 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="0.25"
        y="0.293945"
        width="53.5212"
        height="29.0316"
        fill="#080324"
        stroke="white"
        strokeWidth="0.5"
      />
      <path
        d="M22.9141 7.40723H31.974V22.2125H22.9141V7.40723Z"
        fill="#FF5F00"
      />
      <path
        d="M23.8258 14.809C23.8247 13.387 24.1466 11.9834 24.7672 10.7043C25.3878 9.42528 26.2908 8.30435 27.4079 7.42637C26.0244 6.33754 24.3628 5.66047 22.6132 5.47252C20.8635 5.28458 19.0963 5.59335 17.5136 6.36354C15.9309 7.13374 14.5966 8.33429 13.663 9.82797C12.7294 11.3217 12.2344 13.0482 12.2344 14.8103C12.2344 16.5724 12.7294 18.299 13.663 19.7927C14.5966 21.2864 15.9309 22.4869 17.5136 23.2571C19.0963 24.0273 20.8635 24.3361 22.6132 24.1481C24.3628 23.9602 26.0244 23.2831 27.4079 22.1943C26.2905 21.316 25.3873 20.1947 24.7667 18.9152C24.1461 17.6356 23.8243 16.2315 23.8258 14.809V14.809Z"
        fill="#EB001B"
      />
      <path
        d="M42.6534 14.8117C42.6534 16.5737 42.1559 18.3002 41.2177 19.7937C40.2795 21.2873 38.9386 22.4877 37.3481 23.2577C35.7577 24.0277 33.9819 24.3362 32.2239 24.148C30.4658 23.9598 28.7963 23.2825 27.4062 22.1934C28.5282 21.3148 29.4352 20.1937 30.059 18.9147C30.6827 17.6357 31.0067 16.2323 31.0067 14.8103C31.0067 13.3883 30.6827 11.9849 30.059 10.706C29.4352 9.427 28.5282 8.3059 27.4062 7.42724C28.7963 6.33819 30.4658 5.66086 32.2239 5.47266C33.982 5.28447 35.7577 5.593 37.3482 6.363C38.9386 7.133 40.2795 8.33339 41.2177 9.82696C42.1559 11.3205 42.6534 13.047 42.6534 14.809V14.8117Z"
        fill="#F79E1B"
      />
    </svg>
  )
}

export default MasterCardIcon
